import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {formValueSelector} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {isMasterUser, isCareSheetsSupported} = customer.selectors;

import {deselectUser, saveUser, toggleUserPermission, savePasswordChange} from '../actions';
import {getSelectedUser, getSelectedPermissions} from '../selectors';

import EditUserForm from './EditUserForm';

const formName = 'editUserForm';
const formSelector = formValueSelector(formName);

class EditUserPage extends React.Component {
  constructor(props)
  {
    super(props);

    this.state = {
      modalOpen: false,
      newPassword: '',
      confirmPassword: '',
      passwordError: ''
    };
  }
  
  componentWillMount() {
    if(!this.props.isMasterUser)
    {
      this.props.actions.push('/labels');
    } 

    if(Object.keys(this.props.selectedUser).length === 0) {
      this.props.actions.push('/users');
    }
  }

  componentWillUnmount() {
    this.props.actions.deselectUser();
  }

  handleFormSubmit = (values) => {
    return new Promise((resolve, reject) => {
      this.props.actions.saveUser(this.props.selectedUser.userName, values, this.props.permissionTable)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  };

  handleFormCancel = () => {
    this.props.actions.push('/users');
  }

  handleFormValidation = (values) => {
    const errors = {};

    if(!values.firstName) {
      errors.firstName = I18n.t('PLEASE_ENTER_FIRST_NAME');
    }

    if(!values.lastName) {
      errors.lastName = I18n.t('PLEASE_ENTER_LAST_NAME');
    }

    return errors;
  };

  handlePasswordOpen = () => {
    this.setState({modalOpen: true});
  }

  handlePasswordClose = () => {
    this.setState({modalOpen: false});
    this.setState({newPassword: ''});
    this.setState({confirmPassword: ''});
    this.setState({passwordError: ''});
  };

  handlePasswordAccept = () => {
    if(this.state.newPassword.length < 8)
    {
      let errorMsg = I18n.t('PASSWORD_CHARACTERS');
      this.setState({passwordError: errorMsg});
    } 
    else if(this.state.newPassword !== this.state.confirmPassword)
    {
      let errorMsg = I18n.t('PASSWORDS_DO_NOT_MATCH');
      this.setState({passwordError: errorMsg});
    }
    else {
      this.props.actions.savePasswordChange(this.props.selectedUser.userName, this.state.newPassword);
      this.handlePasswordClose();
    }
  };

  handlePasswordChange = (password) => {
    this.setState({newPassword: password});
    if(password.length < 8)
    {
      let errorMsg = I18n.t('PASSWORD_CHARACTERS');
      this.setState({passwordError: errorMsg});
    } 
    else if(password !== this.state.confirmPassword)
    {
      let errorMsg = I18n.t('PASSWORDS_DO_NOT_MATCH');
      this.setState({passwordError: errorMsg});
    } 
    else {
      this.setState({passwordError: ''});
    }
  }

  handleConfirmPasswordChange = (password) => {
    this.setState({confirmPassword: password});
    if(this.state.newPassword.length < 8)
    {
      let errorMsg = I18n.t('PASSWORD_CHARACTERS');
      this.setState({passwordError: errorMsg});
    }
    else if(password !== this.state.newPassword)
    {
      let errorMsg = I18n.t('PASSWORDS_DO_NOT_MATCH');
      this.setState({passwordError: errorMsg});
    } else {
      this.setState({passwordError: ''});
    }
  }

  render() {
    const {actions, permissionTable, selectedUser, status, supportsCareSheets} = this.props;
    return (
      <EditUserForm form={formName} 
                    initialValues={{firstName: selectedUser.firstName, 
                                    lastName: selectedUser.lastName,
                                    status: selectedUser.isActive}}
                    onCancel={this.handleFormCancel}
                    onTogglePermission={actions.toggleUserPermission}
                    onSubmit={this.handleFormSubmit}
                    permissionTable={permissionTable}
                    status={status}
                    subscriptions={selectedUser.subscriptions}
                    username={selectedUser.userName}
                    validate={this.handleFormValidation}
                    modalOpen={this.state.modalOpen}
                    onOpenModal={this.handlePasswordOpen}
                    onCloseModal={this.handlePasswordClose}
                    onPasswordAccept={this.handlePasswordAccept}
                    newPassword={this.state.newPassword}
                    confirmPassword={this.state.confirmPassword}
                    passwordError={this.state.passwordError}
                    onPasswordChange={this.handlePasswordChange}
                    onConfirmPasswordChange={this.handleConfirmPasswordChange}
                    supportsCareSheet = {supportsCareSheets}

      />
    );
  }
}

function mapStateToProps(state) {
  return {
    isMasterUser: isMasterUser(state),
    permissionTable: getSelectedPermissions(state),
    selectedUser: getSelectedUser(state),
    status: formSelector(state, 'status'),
    supportsCareSheets: isCareSheetsSupported(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({deselectUser, push, saveUser, toggleUserPermission, savePasswordChange}, dispatch)
  };
}

EditUserPage.propTypes = {
  actions: PropTypes.object.isRequired,
  isMasterUser: PropTypes.bool.isRequired,
  permissionTable: PropTypes.array.isRequired,
  selectedUser: PropTypes.object.isRequired,
  status: PropTypes.bool.isRequired,
  supportsCareSheets: PropTypes.bool.isRequired,
};

EditUserPage.defaultProps = {
  status: false
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUserPage);


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/EditUserPage.js
 **/